import BaseModel from "./BaseModel";

export default class SanadModel extends BaseModel {
  recitation?: string;
  type?: string;
  certificate_url?: string;
  constructor(arg: any) {
    super(arg);
    this.recitation = arg.recitation;
    this.type = arg.type;
    this.certificate_url = arg.certificate_url;
  }
}
